import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { CSSProperties } from 'react';
import promotionResultsPage from '~/assets/images/promotionResultsPage.svg';
import { COLORS } from '~/data/ui/colors';
import theme, { extraThinMobileWidth, thinMobileWidth } from '~/theme';

const useStyles = () => ({
  root: {
    border: `1px solid ${COLORS.gray.dark5}`,
    borderRadius: '8px',
    background: 'white',
    position: 'relative',
    transition: 'all 0.16s ease',
    '&:hover': {
      border: `1px solid transparent`,
      boxShadow: `0 0 0 2px ${COLORS.primary.main}`,
    },
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '100%',
    },
  },
  '& .carousel .control-dots .dot.selected, .carousel .control-dots .dot:hover ':
    {
      opacity: 1,
      backgroundColor: 'yellow',
    },

  cardContainer: {
    padding: '12px 16px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  topLabelWidget: {
    minHeight: '27px',
    marginTop: '12px',
  },
  carTitle: {
    display: 'flex',
    flexDirection: 'column',
  },
  sliderContainer: {
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  specialPriceIcon: {
    position: 'absolute',
    right: '8px',
    top: '12px',
    cursor: 'pointer',
  },

  wishlistIcon: {
    display: 'flex',
    position: 'absolute',
    left: '8px',
    top: '12px',
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomLabel: {
    display: 'flex',
    position: 'absolute',
    right: -16,
    top: '12px',
    justifyContent: 'center',
    alignItems: 'center',
  },

  priceWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    marginTop: '12px',
    marginBottom: '2px',
  },

  priceStyles: {
    marginTop: '12px',
  },

  toolTipButton: {
    border: 'none',
    fontFamily: 'EricaSansFOT,GillSans',
    fontWeight: '800',
    backgroundColor: 'transparent',
    color: `${COLORS.primary.dark2}`,
    fontSize: '18px',
    cursor: 'pointer',
    '&.MuiTypography-root': {
      fontSize: '16px',
    },
  },

  toolTipWrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '14px',
  },
  upSaleIcon: {
    position: 'absolute',
    left: '130px',
    bottom: '2px',
    zIndex: '-100',
  },

  goToCarButton: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginTop: '17px',
    width: '-webkit-fill-available',
  },

  upsaleText: {
    '&.MuiTypography-root': {
      fontSize: '16px',
    },
  },

  promotionStyle: {
    backgroundImage: `url(${promotionResultsPage.src})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    height: '250px',
    width: '100%',
    top: '0',
  },

  subscriptionBackgroundStyle: {
    position: 'absolute',
    left: '35px',
    top: '0px',
  },
  subscriptionModelNameSpacer: {
    marginTop: '48px',
  },
  btnsDivStyle: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
  },
});

export default useStyles;

export const brandNameStyle = {
  marginTop: '15px',
  fontSize: '16px',
  fontWeight: '400',
};

export const modelNameStyle = {
  marginTop: '4px',
  marginBottom: '10px',
  fontSize: '24px',
  width: '100%',
  lineHeight: '24px',
  textTransform: 'uppercase',
  fontFamily: 'EricaSansFOT,GillSans',
  fontWeight: '800',
};

export const buttonStyle = {
  width: '100%',
  marginTop: '8px',
  flexDirection: 'row-reverse',
  fontSize: '16px',
  gap: '5px',
  flex: 1,
};
export const priceStyle = {
  fontSize: '32px',
  fontFamily: 'EricaSansFOT,GillSans',
  fontWeight: '800',
  position: 'relative',
  lineHeight: 'normal',
  zIndex: '1',
  display: 'flex',
  alignItems: 'end',
  gap: '5px',
};
export const priceListStyle = {
  fontSize: '16px',
  minWidth: '200px',
  fontWeight: 400,
  display: 'block',
};

export const taxNoticeStyle = {
  fontSize: '11px',
  fontWeight: 200,
  display: 'block',
};

export const priceListCarCardStyle = {
  fontSize: '16px',
  lineHeight: 'normal',
};
export const contactUsButton: CSSProperties = {
  flex: 1,
  padding: 0,
  marginTop: '8px',
  zIndex: 0,
};

export const iconBackground = {
  position: 'absolute',
  left: '0',
  width: '83px',
  height: '83px',
  marginLeft: '20px',
  marginTop: '20px',
};

export const iconFrameZero = {
  position: 'absolute',
  right: '0',
  top: '50%',
  transform: 'translate(6% ,380%)',
};

export const contactUsButtonText = {
  fontWeight: '400',
};
export const hrefBtnStyle = { textDecoration: 'none', flex: 1 };

export const SubscriptionBackgroundStyle = styled('svg')(() => ({
  position: 'absolute',
  left: '35px',
  top: '0px',
}));

export const bottomContainer = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: '8px',
};

export const contentContainer = {
  width: 'fit-content',
  whiteSpace: 'nowrap',
  flexGrow: 1,
  marginBottom: '100px',
};

export const frameCampaign = {
  transform: 'translate(16%, -160%)',
  position: 'absolute',
  width: '155px',
  zIndex: '10',
  [theme.breakpoints.down('md')]: {
    transform: 'translate(16%, -170%)',
  },
};

export const timerContainer = {
  display: 'flex',
  alignItems: 'center',
  marginTop: '8px',
};

export const timer = {
  position: 'absolute',
  top: '0',
  transform: 'translate(-20%, 22%)',
  fontSize: '12px',
  fontWeight: '400',
  alignItems: 'center',
  display: 'flex',
  gap: '4px',
};

export const timerStyle = {
  color: `${COLORS.red.dark5}`,
  paddingLeft: '5px',
};

export const timerText = {
  color: `${COLORS.black.dark}`,
  fontSize: '12px',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
  },
};

export const timerIcon1 = {
  width: '20px',
  height: '20px',
  marginRight: '-10px',
};

export const iconCampaign = {
  position: 'absolute',
  width: '435px',
  height: '486px',
  left: -10,
  top: 0,
  zIndex: 0,

  [theme.breakpoints.down('md')]: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    width: '400px',
    height: '456px',
    top: '27px',
    left: '-5px',
    backgroundSize: 'contain',
  },
};

export const customWishlistStyles = {
  minWidth: 'unset',
  border: '.5px solid black',
  borderRadius: '50%',
  width: 'unset',
  height: 'unset',
  padding: '8px',
};

export const yellowLineContainerStyles = {
  position: 'absolute',
  right: '7px',
  maxWidth: '70%',
  top: '11px',
  zIndex: '-1',
};
export const yellowLineLeaseContainerStyles = {
  right: '3px',
  maxWidth: '63%',
};

export const yellowLineStyles = { maxWidth: '100%' };

export const bulletsContainer = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  [theme.breakpoints.down(extraThinMobileWidth)]: {
    maxWidth: '200px',
  },
};
export const StyledBulletIcon = styled('svg')(() => ({
  width: '15px',
}));
export const bulletTextStyles = {
  fontSize: '14px',
  color: COLORS.gray.dark,
  [theme.breakpoints.down(thinMobileWidth)]: {
    fontSize: '13px',
    lineHeight: 'normal',
  },
};
export const tooltipCustomStyles = {
  maxWidth: '16px',
  padding: '0',
  marginRight: '8px',
};
export const bottomPriceContainer = { display: 'flex', alignItems: 'center' };
export const topLabelStyles = { backgroundColor: COLORS.yellow.light1 };

export const StyledBlueLine = styled('svg')(() => ({
  width: '100%',
  maxHeight: '300px',
}));

export const StyledBottomLabelBox = styled(Box)(() => ({
  position: 'absolute',
  right: '0',
  top: '55%',
  transform: 'translate(6%, 350%)',
}));
export const StyledFamilyCarPromoBox = styled(Box)(() => ({
  position: 'absolute',
  right: 0,
  top: '31%',
  width: '100%',
  height: '113px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  zIndex: 3,
}));
